export default "/images/image 125.png";